/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Newsletter_Archive_EmptyInputs */

const en_newsletter_archive_empty = /** @type {(inputs: Newsletter_Archive_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The first one is in the works. Subscribe and it lands in your inbox the moment it ships.`)
};

/**
* | output |
* | --- |
* | "The first one is in the works. Subscribe and it lands in your inbox the moment it ships." |
*
* @param {Newsletter_Archive_EmptyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const newsletter_archive_empty = /** @type {((inputs?: Newsletter_Archive_EmptyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newsletter_Archive_EmptyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_newsletter_archive_empty(inputs)
});